import { inject, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../components/legacy/toast/toast.service';
import { ModalService } from '../../components/legacy/modal/modal.service';
import { ToastOptions } from '../../components/legacy/toast/model/toast-options';

@Injectable()
export class NotificationService {
  private toastService = inject(ToastService);
  private translate = inject(TranslateService);
  private modalService = inject(ModalService);

  public showSuccessToast(message: string, options: ToastOptions = {}) {
    return this.toastService.success(this.translate.instant(message), options);
  }

  public showInfoToast(
    message: string,
    options: ToastOptions = {},
    interpolateParams?: Record<string, unknown>
  ) {
    return this.toastService.info(
      this.translate.instant(message, interpolateParams),
      options
    );
  }

  public showErrorToast(
    message: string,
    options: ToastOptions = {},
    interpolateParams?: Record<string, unknown>
  ) {
    return this.toastService.error(
      this.translate.instant(message, interpolateParams),
      options
    );
  }

  public showWarningToast(message: string, options: ToastOptions = {}) {
    return this.toastService.warning(this.translate.instant(message), options);
  }

  public showInfoModal(
    titleMessage: string,
    message: string,
    okButtonMessage: string = null,
    innerHTML = false
  ) {
    const data = {
      titleMessage: titleMessage,
      message: message,
      okButtonMessage: okButtonMessage,
      innerHTML
    };
    return this.modalService.openAcknowledgement({ data: data });
  }
}
